<template>
  <div
    v-block-loading="loading"
    class="m-detail-markets"
  >
    <template v-if="!loading">
      <div :class="['m-sub-navs-wrapper', { special: hasWidget }]">
        <VSnapNav
          v-if="marketList.length"
          :value="marketGroup"
          :class="['m-sub-navs', { 'm-sub-navs-special': hasWidget }]"
          @change="onChangeMarketGroup"
        >
          <template v-for="(item, index) in marketList">
            <VSnapNavItem
              :key="item.name"
              class="m-sub-nav-item"
              :name="item.name"
              :order="index"
            >
              <span class="m-group">
                <template v-if="item.name === FAVOURITE_MARKETS_KEY">
                  <transition name="slide-fade">
                    <span
                      v-if="animaeAddOne"
                      class="m-add-one"
                      >{{ favouriteText }}</span
                    >
                  </transition>
                </template>
                {{ item.name }}
                <Tag v-if="item.tagNew === 1"> New </Tag>
              </span>
            </VSnapNavItem>
          </template>
        </VSnapNav>

        <button
          type="button"
          class="collapse-toggler"
          style="color: white"
          @click="handleCollapseTogglerClick"
        >
          <img
            :src="collapseTogglerIcon"
            class="icon"
          />
        </button>
      </div>

      <p
        v-if="marketGroup === 'Goals' && marketPlayerVisible"
        class="market-player-note"
      >
        Kindly notice that markets “1st goalscorer, last goalscorer and anytime goalscorer” have been moved to Group “Player Props”.

        <a
          class="btn-close"
          @click="handleCloseNote"
        >
          <img
            src="../images/close.png"
            alt="close"
          />
        </a>
      </p>

      <keep-alive>
        <!-- my favourite -->
        <MarketList
          v-if="loginStatus && marketGroup === FAVOURITE_MARKETS_KEY"
          :market-ids="validFavoriteIds"
          :name="FAVOURITE_MARKETS_KEY"
          @favourite="onFavourite"
        />
        <template v-for="(item, index) in marketList">
          <MarketList
            v-if="item.name === marketGroup && marketGroup !== 'Bet Builder'"
            :key="index"
            :name="item.name"
            :market-ids="marketGroupIdsMap[item.name]"
            @favourite="onFavourite"
          />
        </template>

        <MarketComboList
          v-if="marketGroup === 'Bet Builder'"
          v-block-loading:getBetBuilder="customBetLoading"
          :name="marketGroup"
          :loading="customBetLoading !== -1 ? customBetLoading : true"
        />
      </keep-alive>
    </template>
  </div>
</template>

<script>
import { ref, computed, onMounted, getCurrentInstance } from '@vue/composition-api'
import VSnapNav from 'fe-vui/snapNav'
import VSnapNavItem from 'fe-vui/snapNavItem'
import { storeToRefs } from 'pinia'
import { REGION } from '@ms/config/app'
import { useAuthStore } from '@ms/stores/auth'
import { useMatchDetailStore } from 'wap/stores/matchDetail'
import { useDetailStore } from '@ms/stores/matchDetail'
import { useWapBetslipStore } from 'wap/stores/betslip'
import { isBetBuilderSelection } from '@ms/stores/betslip/func'
import useMatchInfo from '@ms/components/match/useMatchInfo.js'
import { useMarketGroup } from '@ms/components/matchDetail/useMarket.js'
import eventBus from '@ms/utils/event-bus.js'
import MarketList from './MarketList'
import MarketComboList from './MarketComboList'
import Tag from 'wap/components/Tag.vue'
import { useExpandedMarkets } from 'composables/useExpandedMarkets.js'
import collapseIcon from 'base/icons/png/collapse.png'
import expandIcon from 'base/icons/png/expend.png'

const MARKET_PLAYER_NOTE = REGION + 'market-player-note'

export default {
  name: 'MarketListContainer',
  components: {
    VSnapNav,
    VSnapNavItem,
    MarketList,
    MarketComboList,
    Tag
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    hasWidget: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const { proxy: vm } = getCurrentInstance()
    const auth = useAuthStore()
    const { loginStatus } = storeToRefs(auth)
    const { isLive } = useMatchInfo()
    const { marketGroup, updateMarketGroup } = useMarketGroup()

    const matchDetailStore = useMatchDetailStore()
    const { event, marketGroupList, favouriteMarketIds } = storeToRefs(matchDetailStore)

    const { selectionList } = storeToRefs(useWapBetslipStore())

    const { comboMarket } = storeToRefs(useDetailStore())

    const customBetLoading = ref(false)

    // handle market expand
    const { expandedMarketGroupMap, marketGroupIdsMap, activeMarketIds, initExpandedMarkets, initBetBuilderMarkets, initFavouriteMarkets, resetFavouriteMarketGroup } = useExpandedMarkets()

    const areSomeActiveMarketsExpanded = computed(() => {
      const marketIdList = expandedMarketGroupMap.value[marketGroup.value] ?? []
      return marketIdList.some((id) => activeMarketIds.value.includes(id))
    })
    const isMarketGroupEmpty = computed(() => {
      const marketIdList = marketGroupIdsMap.value[marketGroup.value] ?? []
      return marketIdList.length === 0
    })
    const shouldShowCollapse = computed(() => areSomeActiveMarketsExpanded.value || isMarketGroupEmpty.value)
    const collapseTogglerIcon = computed(() => (shouldShowCollapse.value ? collapseIcon : expandIcon))

    const handleCollapseTogglerClick = () => {
      if (shouldShowCollapse.value) {
        window.mstrace('MatchDetail_CollapseAll', '', { click_text: 'Collapse All' })
        eventBus.$emit('collapse-toggler-click', {
          shouldCollapse: shouldShowCollapse.value
        })
        return
      }

      window.mstrace('MatchDetail_CollapseAll', '', { click_text: 'Expand All' })
      eventBus.$emit('collapse-toggler-click', {
        shouldCollapse: shouldShowCollapse.value
      })
    }

    onMounted(() => {
      initExpandedMarkets({
        favouriteMarketIds: vm.validFavoriteIds,
        markets: event.value.markets
      })
    })

    // onUnmounted(() => {
    //   resetExpandedMarkets()
    // })

    return {
      loginStatus,
      isLive,
      marketGroup,
      updateMarketGroup,
      event,
      marketGroupList,
      favouriteMarketIds,
      comboMarket,
      customBetLoading,
      selectionList,
      expandedMarketGroupMap,
      marketGroupIdsMap,
      shouldShowCollapse,
      collapseTogglerIcon,
      handleCollapseTogglerClick,
      initExpandedMarkets,
      initFavouriteMarkets,
      initBetBuilderMarkets,
      resetFavouriteMarketGroup
    }
  },
  data() {
    return {
      // marketPlayerVisible: !localStorage.getItem(MARKET_PLAYER_NOTE),
      marketPlayerVisible: false, // 暂时关闭
      animaeAddOne: false,
      FAVOURITE_MARKETS_KEY: 'Favourites',
      favouriteText: '+1' // +1, -1
    }
  },
  computed: {
    marketList() {
      const list = this.marketGroupList.filter((x) => {
        // premium cricket product 为 5, 不区分
        if (x.product === 5) {
          return true
        }
        if (this.isLive) {
          return x.product === 1
        } else {
          return x.product === 3
        }
      })
      if (this.loginStatus) {
        list.unshift({
          name: this.FAVOURITE_MARKETS_KEY
        })
      }
      return list
    },
    validFavoriteIds() {
      const { order } = this.event.markets
      const arr = []
      this.favouriteMarketIds.forEach((marketId) => {
        // id 不一定等于 marketId，可能是 marketId + specifiers
        const reg = new RegExp(`^${marketId}_`)
        const ids = order.filter((id) => id === marketId || reg.test(id))
        arr.push(...ids)
      })
      return arr.reverse()
    }
  },
  watch: {
    marketList: {
      immediate: true,
      async handler(val) {
        if (val && val.length) {
          const { group } = this.$route.query
          if (group) {
            if (this.marketGroup) return false
            const tab = decodeURIComponent(group)
            this.updateMarketGroup(decodeURIComponent(tab))
            if (tab === 'Bet Builder') {
              await this.getBetBuilder()
              this.initBetBuilderMarkets({
                comboMarketGroups: this.comboMarket?.comboMarketGroups
              })
            }
          } else if (!this.marketGroup) {
            const marketGroup = this.loginStatus ? val[1].name : val[0].name
            this.updateMarketGroup(marketGroup)
          }
        }
      }
    },
    marketGroup() {
      eventBus.$emit('update-mini-footer')
    },
    validFavoriteIds(value) {
      this.initFavouriteMarkets({
        favouriteMarketIds: value,
        markets: this.event.markets
      })
    }
  },
  methods: {
    onFavourite(status) {
      this.resetFavouriteMarketGroup()
      this.initFavouriteMarkets({
        favouriteMarketIds: this.validFavoriteIds,
        markets: this.event.markets
      })

      this.animaeAddOne = true
      this.favouriteText = status ? '+1' : '-1'
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.animaeAddOne = false
      }, 800)
    },
    async onChangeMarketGroup(marketGroup) {
      if (this.marketGroup === 'Goals' && marketGroup !== this.marketGroup) {
        this.handleCloseNote()
      }
      this.updateMarketGroup(marketGroup)
      if (marketGroup === 'Goals') {
        // 展示一次后不再展示
        localStorage.setItem(MARKET_PLAYER_NOTE, 1)
      }

      const query = { ...this.$route.query }
      if (marketGroup === 'Bet Builder') {
        await this.getBetBuilder()
        this.initBetBuilderMarkets({
          comboMarketGroups: this.comboMarket?.comboMarketGroups,
          updateExpandMode: 'append'
        })
        if (query.group !== 'Bet Builder') {
          this.$router.replace({ query: { ...query, group: 'Bet Builder' } })
        }
      } else {
        if (query.group) {
          delete query.group
          this.$router.replace({ query })
        }
      }
    },
    async getBetBuilder() {
      try {
        if (!this.comboMarket || !this.comboMarket?.comboMarketGroups?.length || this.customBetLoading === -1) {
          this.customBetLoading = true
          this.getConflict()
        }
        const { bizCode } = await useDetailStore().getComboMarkets(this.event.eventId)
        if (bizCode === 10000) this.customBetLoading = false
        else this.customBetLoading = -1
      } catch (error) {
        this.customBetLoading = -1
        console.error(error)
      }
    },
    async getConflict() {
      let markets = []
      const selections = this.selectionList.filter((x) => isBetBuilderSelection(x) && x.eventId === this.event.eventId)
      if (selections.length) {
        markets = selections[0].betBuilderSelections.map((selection) => {
          return {
            outcome: selection.outcomeInfo,
            market: selection.marketInfo
          }
        })
      }

      if (!markets.length) return false
      try {
        useDetailStore().getConflictMarkets(markets, false, this.event.eventId)
      } catch (error) {
        console.error(error)
      }
    },
    handleCloseNote() {
      this.marketPlayerVisible = false
      localStorage.setItem(MARKET_PLAYER_NOTE, 1)
    }
  }
}
</script>

<style lang="less">
@import url('~wap/common/style/variable.less');
@import url('../style/market.less');

.m-detail-markets {
  .m-sub-navs-wrapper {
    position: sticky;
    z-index: 1000;
    top: 44px;

    .m-sub-navs {
      display: flex;
      overflow: hidden;
      min-width: 100%;
      max-width: 750px;
      box-sizing: border-box;
      align-items: center;
      justify-content: center;

      .snap-nav {
        height: 44px;
        box-sizing: border-box;
        align-items: center;
        padding-right: 67px;
        padding-left: 16px;
        background: #161616;

        .snap-nav-item {
          height: 24px;
        }
      }

      .m-sub-nav-item {
        box-sizing: border-box;
        padding: 0 8px;
        border-radius: 12px;
        margin-right: 8px;
        background: #333;
        color:#d9d9d9;
        line-height: 24px;
        text-transform: capitalize;

        .item-label {
          display: inline-block;
          min-width: 44px;
        }

        &.active {
          background:linear-gradient(293.43deg,#ffe74f 0%,#ffad31 100%),linear-gradient(293.43deg,#ffe74f 0%,#ffad31 100%);
          color: #000;
          font-weight: 700;
        }

        &:first-child {
          padding-left: 10px;
        }

        &:last-child {
          padding-right: 10px;
        }

        .m-group {
          position: relative;

          .m-add-one {
            position: absolute;
            z-index: 1;
            top: -10px;
            right: 2px;
            color: @primary;
            font-size: 10px;
            line-height: 12px;
          }

          .tag {
            position: absolute;
            top: -11px;
            right: -18px;
          }
        }
      }
    }

    .collapse-toggler {
      position: absolute;
      z-index: 2;
      top: 0;
      right: 0;
      display: flex;
      width: 52px;
      height: 44px;
      box-sizing: border-box;
      align-items: center;
      justify-content: center;
      background-color: #141414;
      box-shadow: -26px 0 26px #000;
      
      .icon {
        width: 20px;
        height: 20px;
      }
    }

    &.special {
      top: 138px;
    }
  }
}

/* 可以设置不同的进入和离开动画 */

/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(10px);
}

.market-player-note {
  position: relative;
  padding: 10px 49px 10px 16px;
  background: #fff0c4;
  color: #000;
  font-family: PingFangSC-Regular, Helvetica, Arial, sans-serif;
  font-size: 12px;

  .btn-close {
    position: absolute;
    top: 6px;
    right: 15px;
    padding: 5px;

    img {
      display: block;
      width: 14px;
      height: 14px;
    }
  }
}
</style>

<style lang="scss" scoped>
[data-mode="light"] {
  .m-detail-markets {
    .collapse-toggler {
      background: #fff;
      box-shadow: -23px 0 16px 1px rgba(215, 215, 215, 35%);
    }

    ::v-deep {
      .snap-nav {
        background: #fff;
      }

      .m-sub-nav-item {
        background:#f7f7f7;
        color:#333;
      }
    }
  }

  .m-detail-top-header.fixed ~ .match-container .m-sub-navs-wrapper {
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 11%);
  }
}
</style>
